export default __webpack_public_path__ + "static/media/Golden-Snitch-Rigged-02.a55e0444.jpg";